import React, { useEffect } from 'react';

export default function StructuredData({ data, id = 'structured-data' }) {
    useEffect(() => {
        if (!data) return;

        const sanitizeJsonLd = (obj) => {
            if (typeof obj !== 'object' || obj === null) {
                return typeof obj === 'string' ? obj.replace(/</g, '\\u003c') : obj;
            }
            
            if (Array.isArray(obj)) {
                return obj.map(sanitizeJsonLd);
            }
            
            const sanitized = {};
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    sanitized[key] = sanitizeJsonLd(obj[key]);
                }
            }
            return sanitized;
        };

        const existingScript = document.getElementById(id);
        if (existingScript) {
            existingScript.remove();
        }

        const script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        
        try {
            const sanitizedData = sanitizeJsonLd(data);
            script.textContent = JSON.stringify(sanitizedData, null, 2);
            document.head.appendChild(script);
        } catch (error) {
            console.error('Error creating structured data:', error);
        }

        return () => {
            const scriptToRemove = document.getElementById(id);
            if (scriptToRemove) {
                scriptToRemove.remove();
            }
        };
    }, [data, id]);

    return null;
}
